const f = {
  color: {
    outline: "#47c47dff",
    boxShadow: "#abb9c7ff",
    circle: {
      default: "#f9fafaff",
      happy: "#ffeeccff",
      sad: "#ebf5ffff",
      okay: "#f1f3f5ff"
    }
  }
};
export {
  f as rateAction
};
